import { API_ROUTE_ADMIN_LOCATIONS_DETAILS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { AssetLocationOriginal } from './types'

const IS_NEW_BACKEND_API = true

type AssetLocationDetailsOriginal = AssetLocationOriginal & {
  createdDate: string
  editedDate: string
  createdBy: {
    id: number
    firstName: string
    lastName: string
  } | null
  editedBy: {
    id: number
    firstName: string
    lastName: string
  } | null
  dim1: string | null
  dim2: string | null
  dim3: string | null
  dim4: string | null
}

export async function getDetails(id: number) {
  return get<AssetLocationDetailsOriginal>(
    API_ROUTE_ADMIN_LOCATIONS_DETAILS.replace(':costObjectId', String(id)),
    IS_NEW_BACKEND_API
  )
}
